// src/helpers/auth.js
import Cookies from "js-cookie";
import { TOKEN_STORE_KEY } from "@/constants/storage";
import { fetchUserInfo, setUser } from "@/redux/slices/userSlice";
import UserService from "@/services/api/UserService";

/**
 * Handles login after registration or manual login.
 *
 * @param {Object} values - Login payload { phone, password }
 * @param {Function} dispatch - Redux dispatch function
 * @param {Function} toast - Toast function for success/error
 * @param {Function} setDrawerOpen - Function to close drawer
 */
export const loginAfterAuthSuccess = async (
  values,
  dispatch,
  toast,
  setDrawerOpen,
  router,
  pageType = null,
  pathName = ""
) => {
  console.log("pathName", pathName);
  const response = await UserService.login(values);

  if (response?.data) {
    const { token, user } = response.data;

    if (token) {
      Cookies.set(TOKEN_STORE_KEY, token, { expires: 7 });
      if (user) {
        dispatch(setUser(user));
        dispatch(fetchUserInfo());

      }
      toast.success(response.message || "সফলভাবে লগ ইন করেছেন", {
        autoClose: 1000,
      });
      setDrawerOpen();
      if (pageType === "login" || pathName === "/login") {
        router.push("/");
      }
    }
  }
};
